import {mapState, mapActions} from 'vuex';
import {TimelineMax, TweenLite} from 'gsap';
// import Swiper from 'swiper';
const elementsTracking = require('../../../../viscomjs/analytics/elementsTracking');
const SizesUtils = require('../../../../viscomjs/utils/SizesUtils');
// const getSizeMode = require('../../utils/getSizeMode');
// const win = window;

// const __getSizeMode = getSizeMode;

const __getSizeClass = () => {
    const w = SizesUtils.winWidth();
    const h = SizesUtils.winHeight();

    if (w < h && w < 425) return 'mobile-v';
    if (w >= h && h < 600) return 'mobile-h';
    return 'default';
};
__getSizeClass();

export default {
    name: 'question',
    props: {
        basicData: Object,
        data: Object,
        next: String,
        nextLabel: String
    },
    computed: {
        ...mapState('quiz', {
            lastIncrement: state => state.lastIncrement,
            lastAnswer: state => state.lastAnswer
        }),
        visibility() {
            return this.entered;
        },
        selectedId() {
            return this.selected ? this.selected.id : '';
        },
        selectedLabel() {
            return this.selected ? this.selected.label : '';
        },
        hasAnswer() {
            return this.selected !== null;
        }
    },
    data() {
        return {
            text: [''],
            request: {
                url: '',
                label: ''
            },
            options: [],
            entered: false,
            transitionName: 'in',
            sizeMode: 'default',
            sizeClass: 'default',
            swClass: 'noneSw',
            swMode: false,
            contentVisible: '',
            searchVisible: '',
            optionsVisible: '',
            uiVisible: '',
            selected: null,
            answered: false,
            showLastIncrement: false,
            showLastIncrementDelay: 1.25,
            disappearDelay: 1.25
        };
    },
    mounted() {
        this.update();
        TweenLite.delayedCall(0.01, this.start, [], this);
    },
    beforeDestroy() {
        this.swMode = false;
        TweenLite.killDelayedCallsTo(this.switchOnSwiper);
        if (this._sw) {
            this._sw.destroy(false, true);
        }

        // this.stopResize();
        this.destroyAnalytics();
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.transitionName = 'in';
            vm.nextQuestion();
            vm.entered = true;
        });
    },
    beforeRouteUpdate(to, from, next) {
        if (to.name !== from.name) {
            TweenLite.delayedCall(0.75 + 0.4, next);
            return;
        }
        this.nextQuestion();
        this.refresh();
        TweenLite.delayedCall(0.75 + 0.4, next);
    },
    beforeRouteLeave(to, from, next) {
        this.transitionName = 'out';
        this.entered = false;
        this.hide();
        TweenLite.delayedCall(0.75, next);
    },
    watch: {
        data() {
            this.selected = null;
            this.answered = false;
            this.showLastIncrement = false;
        },
        visibility(to) {
            if (to) this.show();
            else this.hide();
        },
        swMode(to) {
            this.swClass = to ? 'swiper' : 'noneSw';
        },
        sizeMode() {
            //
        }
    },
    methods: {
        ...mapActions('quiz', ['answer', 'nextQuestion']),
        update() {
            this.text = this.data.text;
            this.options = this.data.options;
            this.request = this.data.request;
        },
        start() {
            // this.resize();

            this.startAnalytics();
            // this.startResize();
        },
        show() {
            const delay = this.basicData.quiz.optionsAnimationsDurations[this.lastAnswer] || 0;
            const tl = new TimelineMax({
                delay: delay
            });
            tl.addLabel('st');
            tl.call(this.setContentVisible, [], this, 'st+=' + 0.1);
            tl.call(this.setOptionsVisible, [], this, 'st+=' + 0.25);
            tl.call(this.setUIVisible, [], this, 'st+=' + 0.5);
            tl.call(this.setSearchVisible, [], this, 'st+=' + 0.85);
        },
        hide() {
            const tl = new TimelineMax({
                // delay: 0.4
            });
            tl.addLabel('st');
            tl.call(this.setSearchInvisible, [], this, 'st+=' + 0.15);
            tl.call(this.setUIInvisible, [], this, 'st+=' + 0.25);
            tl.call(this.setOptionsInvisible, [], this, 'st+=' + 0.35);
            tl.call(this.setContentInvisible, [], this, 'st+=' + 0.25);
        },
        showRefresh() {
            this.transitionName = 'change-in';
            const tl = new TimelineMax();
            tl.addLabel('st');
            tl.call(this.setContentVisible, [], this, 'st');
            tl.call(this.setOptionsVisible, [], this, 'st+=' + 0.15);
            tl.call(this.setUIVisible, [], this, 'st+=' + 0.4);
        },
        refresh() {
            this.transitionName = 'change-out';
            const tl = new TimelineMax();
            tl.addLabel('st');
            tl.call(this.setUIInvisible, [], this, 'st+=' + 0.01);
            tl.call(this.setOptionsInvisible, [], this, 'st+=' + 0.15);
            tl.call(this.setContentInvisible, [], this, 'st+=' + 0.15);
            tl.call(this.update, [], this, '+=' + 0.35);
            // tl.call(this.slideToStart, [], this, '+=' + 0.35);
            tl.call(this.showRefresh, [], this, '+=' + 0.36);
        },
        setContentVisible() {
            this.contentVisible = 'active-content';
        },
        setContentInvisible() {
            this.contentVisible = '';
        },
        setUIVisible() {
            this.uiVisible = 'active';
        },
        setUIInvisible() {
            this.uiVisible = '';
        },
        setSearchVisible() {
            this.searchVisible = 'active';
        },
        setSearchInvisible() {
            this.searchVisible = '';
        },
        setOptionsVisible() {
            this.optionsVisible = 'active';
        },
        setOptionsInvisible() {
            this.optionsVisible = '';
        },
        select(item) {
            this.selected = item;
            this.answered = false;
            this.showLastIncrement = false;
        },
        answerQuestion() {
            this.answer({questionId: this.data.id, answerId: this.selectedId});
            this.answered = true;
            this.showLastIncrement = true;

            TweenLite.delayedCall(this.showLastIncrementDelay, this.gotoNext, [], this);
        },
        gotoNext() {
            this.$router.push(this.next);
        },
        startAnalytics() {
            elementsTracking.init(this.$el);
        },
        destroyAnalytics() {
            elementsTracking.destroy(this.$el);
        }
        /*
        switchOnSwiper() {
            this._sw = new Swiper(this.$el.querySelector('.question__container'), {
                effect: 'fade',
                speed: 400,
                spaceBetween: 0,
                snapOnRelease: true,
                transforms3d: true,
                touchMoveStopPropagation: true,
                followFinger: true,
                touchEventsTarget: 'container',
                // forceToAxis: true,
                wrapperClass: 'question__wrap',
                slideClass: 'question__slide',
                navigation: {
                    nextEl: '.question__next',
                    prevEl: '.question__prev'
                },
                fadeEffect: {
                    crossFade: true
                }
            });
        },
        */
        /*
        startResize() {
            win.addEventListener('resize', this.resize);
        },
        stopResize() {
            win.removeEventListener('resize', this.resize);
        },
        
        resize() {
            TweenLite.killDelayedCallsTo(this.__doResize);
            TweenLite.delayedCall(0.01, this.__doResize, [], this);
        },
        __doResize() {
            this.sizeMode = __getSizeMode();
            this.sizeClass = __getSizeClass();
        },
        slideToStart() {
            if (this.sizeMode !== 'mobile' || !this._sw) return;
            this._sw.slideTo(0);
        }
        */
    },
    template: require('../../../../../../components/templates/question.pug')
};
